window.Leaflet = require('leaflet');

$.fn.DBKloadMaps = function () {
    if (!$(this).hasClass('acl-map')) return false;

    let $canvas = $('[id*="map-canvas-"]', this);

    if ($canvas.length > 0) {
        $canvas.css('height', '100%');
    }

    let latitude = $canvas.data('center-lat'),
        longitude = $canvas.data('center-long'),
        zoom = $canvas.data('zoom'),
        markers = $canvas.data('markers') || [],
        assetsUrl = $canvas.data('assets-url'),
        blogName = $canvas.data('blog-name');

    // if on mobile, decrease zoom level
    if (viewport().width < 768) {
        zoom = parseInt(zoom) - 1;
    }

    let map = Leaflet.map($canvas.attr('id'), {
        center: [latitude, longitude],
        zoom: zoom,
        scrollWheelZoom: false,
        tap: false,
        attributionControl: false
    });

    let markerGroup = new Leaflet.FeatureGroup(); // will contain markers, makes fitbounds possible

    // add map tiles
    Leaflet.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=cb1_2mf8_1_0f2622d127eadf711d9fc412', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        maxZoom: 20
    }).addTo(map);

    if (markers) {
        for (const marker of markers) {
            if (marker.lat && marker.long) {
                let myMarker;

                let pin_icon,
                    pin_size = 40;

                if ('small' === marker.size) {
                    pin_size = 30;
                } else if ('large' === marker.size) {
                    pin_size = 50;
                }

                if (viewport().width < 768) {
                    pin_size = pin_size * 0.75;
                }

                if (marker.icon) {
                    if (marker.invert_icon_color) {
                        pin_icon = Leaflet.divIcon({
                            className: 'acl-map__marker-icon acl-map__marker-icon--invert-icon-color',
                            iconSize: [pin_size, pin_size],
                            iconAnchor: [(pin_size / 2), pin_size],
                            popupAnchor: [0, (-1 * pin_size)],
                            html: '<div class="acl-map__marker-icon-inner" style="background-color:' + marker.background_color + ';"><i class="fas fa-' + marker.icon + '"></i></div>'
                        });
                    } else {
                        pin_icon = Leaflet.divIcon({
                            className: 'acl-map__marker-icon',
                            iconSize: [pin_size, pin_size],
                            iconAnchor: [(pin_size / 2), pin_size],
                            popupAnchor: [0, (-1 * pin_size)],
                            html: '<div class="acl-map__marker-icon-inner" style="background-color:' + marker.background_color + ';"><i class="fas fa-' + marker.icon + '"></i></div>'
                        });
                    }
                } else {
                    pin_icon = Leaflet.divIcon({
                        className: 'acl-map__marker-icon acl-map__marker-icon--default',
                        iconSize: [pin_size, pin_size],
                        iconAnchor: [(pin_size/2), pin_size],
                        popupAnchor: [0, (-1*pin_size)],
                        html: '<div class="acl-map__marker-icon-inner" style="background-color:' + marker.background_color + ';"><img src="' + assetsUrl + '/img/theme/pin-icon.svg" alt="Icon ' + blogName + '"></div>'
                    });
                }

                // create marker
                myMarker = Leaflet.marker([marker.lat, marker.long], {icon: pin_icon});

                // add marker id property (corresponding with locations-list location items)
                // myMarker.customMarkerID = 'location-pin-' + location.ID;

                // add marker to marker group
                markerGroup.addLayer(myMarker);

                if (marker.popup_content) {
                    myMarker.bindPopup(marker.popup_content);

                    // if only 1 marker, open popup
                    if (markers.length === 1) {
                        myMarker.openPopup();
                        map.panBy([0, -40]);
                    }
                }

                // zoom on marker click
                myMarker.on('click', function(e){
                    //map.setView(e.latlng, 14).panBy([0, -50]);

                    map.flyTo(e.latlng, 18, {
                        animate: true,
                        duration: 0.5
                    });

                    map.on('zoomend', function () {
                        map.panBy([0, -50]);
                    });
                });
            }
        }

        markerGroup.addTo(map);

        if (markers.length > 1) {
            map.fitBounds(markerGroup.getBounds(), {padding: [50, 50]});
        }
    }

    $('.leaflet-reset-view', this).on('click', function () {
        map.closePopup();

        if (markers && markers.length > 1) {
            map.fitBounds(markerGroup.getBounds(), {padding: [50, 50]});
        } else {
            map.closePopup().setView([latitude, longitude], zoom);
        }
    });
}

// use intersectionObserver to lazy load maps
if ($('.acl-map__canvas').length > 0 && window.viewport().width > 768) {
    const options = {
        threshold: 0
    };

    const callback = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                let $target = $(entry.target);

                if (!$target.find('.leaflet-container').length > 0) {
                    $target.DBKloadMaps();
                }
            }
        });
    };

    const observer = new IntersectionObserver(callback, options);

    const targets = document.querySelectorAll('.acl-map');

    for (const target of targets) {
        observer.observe(target);
    }
}

$('.acl-map__reveal').on('click', function () {
    $(this).closest('.acl-map').DBKloadMaps();
});
